import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, Platform, Linking } from 'react-native';
import { Button, Input, Routes, Screen, Line, Text, Checkbox, Colors } from '../components';
import AuthController from '../controllers/authController';
import { useNavigate } from 'react-router-dom';
import { TouchableOpacity } from 'react-native-web';
import AnimatedCodeInput from "@brainsbeards/react-native-animated-code-input";

class SignInScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display_section: 'phone_input', // 'phone_input', 'validation_code_input', 'email_pw_login'
      phone_number: '',
      phone_number_valid: false,
      validation_code: '',
      email: '',
      password: '',
      tos_accepted: false
    }

    this.update_phone_number = this.update_phone_number.bind(this);
    this.send_phone_code     = this.send_phone_code.bind(this);
    this.validate_phone_code = this.validate_phone_code.bind(this);
    this.login_with_password = this.login_with_password.bind(this);
    this.goNextScreen        = this.goNextScreen.bind(this);
  }

  update_phone_number(phone_number, phone_number_valid) {
    this.setState({
      phone_number,
      phone_number_valid
    })
  }

  async send_phone_code() {
    this.setState({loading: true}, async () => {
      let response = await AuthController.sendPhoneCode({phone: this.state.phone_number});

      console.log('response', response)

      if(response && response.success) {
        this.setState({ loading: false, display_section: 'validation_code_input', password_exists: response.data && response.data.passwordLogin ? response.data.passwordLogin : false })
      } else {
        this.setState({ phone_send_error: response.error, loading: false })
      }
    });
  }

  goNextScreen() {
    this.props.navigate(`${Routes.HOME}`);
  }

  goBack = () => {
    if(Platform.OS === 'web') {
      this.props.navigate(-1);
    } else {
      this.props.navigation.goBack();
    }
  }

  async validate_phone_code() {
    this.setState({loading: true}, async () => {
      let phone    = this.state.phone_number;
      let code     = this.state.validation_code;
      let response = await AuthController.validatePhoneCode({phone, code});

      console.log('response', response)

      if(response && response.success) {
        this.setState({ loading: false, validation_code: '' })
        this.props.onSignIn(true);
        this.goNextScreen();
      } else {
        this.setState({ loading: false, phone_verify_error: response.error, validation_code: '' })
      }
    });
  }

  async login_with_password() {
    this.setState({loading: true}, async () => {
      let email = this.state.email;
      let password = this.state.password;
      let response = await AuthController.loginWithPassword({email, password});

      if(response && response.success) {
        this.setState({ loading: false, email: '', password: '' })
        this.props.onSignIn(true);
        this.goNextScreen();
      } else {
        this.setState({ login_error: response.error, loading: false })
      }
    });
  }

  render_phone_input_section = () => {
    if (this.state.display_section !== 'phone_input') {
      return null;
    }

    let valid = this.state.phone_number_valid;
    let phone_send_error = this.state.phone_send_error;
    let loading = this.state.loading;

    return <View style={{ alignItems: 'center' }}>

      <View style={{ height: 110, width: 330, marginTop: 10 }}>
        <Text style={{ fontSize: 32, fontWeight: '500', textAlign: 'center' }}>Welcome Back!</Text>
        <Text style={{ fontSize: 16, color: '#575762', textAlign: 'center' }}>Enter your phone number to Sign In</Text>
      </View>

      <Input type="phone"
             onChangeText={this.update_phone_number}/>

      {phone_send_error ? <Text style={styles.error_message}>{phone_send_error}</Text> : null}
      <Button title='Continue'
        loading={loading}
        style={{ marginTop: 20 }}
        inactive={!valid}
        onPress={this.send_phone_code}/>
    </View>
  }

  render_tos_pp = () => {

    return <View style={{ flexDirection: 'row', width: 300, marginTop: 30, paddingRight: 10 }}>
      <View style={{ paddingTop: 5 }}>
        <Checkbox checked={this.state.tos_accepted} label_color={ Colors.PRIMARY } style={{ marginRight: 10 }} onPress={ () => { this.setState({ tos_accepted: !this.state.tos_accepted }) }} />
      </View>
      <View style={{ flex: 1 }}>
        <Text style={{ fontSize: 16, color: '#575762', letterSpacing: 0.2 }}>By creating your DodoVet account you are agreeing to our <Text onPress={ () => { Linking.openURL('https://www.teletails.com/tospet') }} style={{ fontWeight: 'bold', color: Colors.PRIMARY }}>Terms & Conditions</Text> and <Text onPress={ () => { Linking.openURL('https://www.teletails.com/privacypolicy') }} style={{ fontWeight: 'bold', color: Colors.PRIMARY }}>Privacy Policy.</Text></Text>
      </View>
    </View>
  }

  render_validation_code_section = () => {
    if (this.state.display_section !== 'validation_code_input') {
      return null;
    }

    let phone_verify_error = this.state.phone_verify_error;
    let password_exists    = this.state.password_exists;
    let loading            = this.state.loading;

    return <View style={{ alignItems: 'center' }}>

      <View style={{ height: 110, width: 330, marginTop: 80 }}>
        <Text style={{ fontSize: 32, fontWeight: 'bold', textAlign: 'center' }}>Validation Code</Text>
        <Text style={{ fontSize: 16, color: '#575762', textAlign: 'center' }}>We’ve texted you a validation code</Text>
      </View>

      <View style={{ width: 300, marginBottom: 20 }}>
        <AnimatedCodeInput
                value={this.state.validation_code}
                numberOfInputs={6}
                codeContainerStyle={{ width: 45, height: 60, borderWidth: 2, borderColor: '#e7e7e7', fontSize: 12 }}
                activeCodeContainerStyle={{ borderWidth: 2, borderColor: Colors.PRIMARY, width: 45, height: 60, paddingTop: Platform.OS === 'web' ? 25 : 0 }}
                textContentType='oneTimeCode'
                textColor='#474747'
                onChangeText={(code) => {
                  this.setState({ ...this.state, validation_code: code });
                }}
                onSubmitCode={() => {
                  this.validate_phone_code();
                }}
              />
      </View>

      { /* <Input placeholder='Code'
             style={{ marginBottom: 30, width: 100, textAlign: 'center' }}
             textContentType='oneTimeCode'
             keyboardType='number-pad'
             onChangeText={ (code) => {
               let code_length = code.length;
               this.setState({ ...this.state, validation_code: code });
               if (code_length === 6) {
                 this.validate_phone_code();
               }
             }}/> */ }
      {phone_verify_error ? <Text style={styles.error_message}>{ phone_verify_error }</Text> : null}
      <Button title='Validate'
              loading={loading}
              style={{ width: 200, marginBottom: 10, }}
              onPress={ this.validate_phone_code }/>

      { password_exists ? <Line style={{ marginBottom: 10, width: 350 }} /> : null }
      { password_exists ? <Button title='Use Email & Password'
                                  style={{  }}
                                  onPress={ () => {
                                    this.setState({ ...this.state, display_section: 'email_pw_login' })
                                  }}/> : null}
    </View>
  }

  render_email_pw_login_section = () => {
    if (this.state.display_section !== 'email_pw_login') {
      return null;
    }

    let login_error = this.state.login_error;
    let loading     = this.state.loading;

    return <View style={{ alignItems: 'center' }}>

      <View style={{ height: 110, width: 330, marginTop: 80 }}>
        <Text style={{ fontSize: 32, fontWeight: 'bold', textAlign: 'center' }}>Email & Password</Text>
        <Text style={{ fontSize: 16, color: '#575762', textAlign: 'center' }}>Sign In by entering the Email Address and Password associated with your account</Text>
      </View>

      <Input label='Email Address'
             style={{ width: 300 }}
             onChangeText={ (email) => {
               this.setState({ ...this.state, email: email });
             }}/>
      <Input label='Password'
             style={{ width: 300 }}
             secureTextEntry={true}
             onChangeText={ (password) => {
               this.setState({ ...this.state, password: password });
             }}/>
      {login_error ? <Text style={styles.error_message}>{login_error}</Text> : null}
      <Button title='Sign In'
              loading={loading}
              style={{ marginTop: 15, width: 240 }}
              onPress={this.login_with_password}/>
    </View>
  }

  back_button_action = () => {
    let current_display_section = this.state.display_section;

    let new_display_section = current_display_section === 'validation_code_input' ? 'phone_input' : '';
        new_display_section = current_display_section === 'email_pw_login'   ? 'validation_code_input' : new_display_section;

    if (current_display_section === 'phone_input') {
      this.goBack();
    } else {
      this.setState({ display_section: new_display_section })
    }
  }

  render() {

    return (
      <Screen navigation={this.props.navigation} left_action={this.back_button_action} bg_white={true} >
        <View style={styles.content_container}>
          { this.render_phone_input_section()     }
          { this.render_validation_code_section() }
          { this.render_email_pw_login_section()  }
        </View>
      </Screen>
    );
  }
}

function SignInScreen(props) {
  if(Platform.OS === 'web') {
    let navigate = useNavigate();
    return  <SignInScreen_Base {...props} navigate={navigate} />
  } else {
    return  <SignInScreen_Base {...props} navigate={props.navigation.push}  />
  }
}

const styles = StyleSheet.create({
  content_container: {
    padding: 15,
    borderRadius: 15,
    backgroundColor: 'white'
  },
  phone_button_valid: { marginTop: 10 },
  phone_button_not_valid: { marginTop: 10 },
  error_message: {
    color: 'red',
    marginTop: 10,
    marginBottom: 10,
  }
});

export default SignInScreen
